import chalk from 'chalk';

import { Cmd } from '../tools/types';

const help: Cmd = {
  name: 'help',
  description: 'Show this help',
  execute({ commands }) {
    const list = [...commands, this].sort((a, b) => a.name.length - b.name.length);
    const maxLength = list[list.length - 1].name.length + 2;
    console.log(`qodly <command>
    
Available commands:

${list
  .map(
    (cmd) =>
      `qodly ${chalk.green(cmd.name.padEnd(maxLength, ' '))} ${cmd.description}.${
        cmd.alias.length ? ` Alias${cmd.alias.length > 1 ? 'es' : ''}: ${cmd.alias.join(', ')}` : ''
      }`,
  )
  .join('\n')}
`);
  },
  alias: [],
};

export default help;
